import { render, staticRenderFns } from "./HeaderSplit.vue?vue&type=template&id=19162bb2&"
import script from "./HeaderSplit.vue?vue&type=script&lang=js&"
export * from "./HeaderSplit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports